import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

function ConfirmPopup({ 
    open,
    onClose,
    confirmYes,
    loading,
    UserId, 
    Address, 
    Country, 
    State, 
    City, 
    Zip, 
    RoutingNumber, 
    AccountNumber, 
    AccountType 
}) {
    const handleConfirmYes = () => {
        confirmYes(UserId, Address, Country, State, City, Zip, RoutingNumber, AccountNumber, AccountType);
    };

    return (
        <Dialog open={open} onOpenChange={loading ? undefined : onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Confirm Bank Account Change</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <Alert variant="destructive">
                        <AlertTriangle className="h-4 w-4" />
                        <AlertDescription>
                            By clicking 'Yes' below your payout account for cashback rewards will be updated 
                            to the new bank account details you provided. No further payments will be sent to 
                            the previous account.
                        </AlertDescription>
                    </Alert>
                </div>

                <DialogFooter className="gap-2">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        disabled={loading}
                    >
                        No
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleConfirmYes}
                        disabled={loading}
                    >
                        {loading
                            ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Saving</>
                            : 'Yes'
                        }
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ConfirmPopup;
